/**
 * Sagas relating to getting/setting configuration parameters for a Sparx
 * Web application, including saving persistent information to browser local
 * storage
 */

import { fromJS, Map } from 'immutable';
import log from 'loglevel';

import { put, takeEvery } from 'redux-saga/effects';
import { ADD_CONFIG_PARAMETERS, addConfigParameters } from './actions';

export const USER_PREFERENCES_KEY = 'sparxweb.preferences';

/**
 * Saga that checks in browser local storage for any saved user preferences
 * and dispatches an action to add them to the store
 */
export function* initConfigParametersFromLocalStorage() {
    try {
        if (localStorage) {
            const storagePrefs = JSON.parse(localStorage.getItem(USER_PREFERENCES_KEY));
            if (storagePrefs) {
                yield put(addConfigParameters(fromJS(storagePrefs), false));
            }
        }
    } catch (err) {
        log.warn('Access to Local Storage Denied.');
    }
}

/**
 * Saga that saves some config parameters in an ADD_CONFIG_PARAMETERS action
 * to local storage
 * @param action
 */
export function* doAddParametersToLocalStorage(action) {
    // Do not process config parameters unless they should be saved to local
    // storage:
    if (!action.saveToLocalStorage) {
        return;
    }

    try {
        if (localStorage) {
            // Get the current parameters:
            let storagePrefs = fromJS(JSON.parse(localStorage.getItem(USER_PREFERENCES_KEY)));

            if (storagePrefs === null) {
                storagePrefs = Map();
            }

            storagePrefs = storagePrefs.merge(action.parameters);

            try {
                yield localStorage.setItem(
                    USER_PREFERENCES_KEY,
                    JSON.stringify(storagePrefs.toJS()),
                );
            } catch (e) {
                log.error('Failed to store config parameters in local storage:', e);
            }
        }
    } catch (e) {
        log.warn('Access to Local Storage Denied.');
    }
}

/**
 * Saga that adds newly added config parameters to local storage if required
 */
export function* watchForNewLocalStorageConfigParameters() {
    yield takeEvery(ADD_CONFIG_PARAMETERS, doAddParametersToLocalStorage);
}
